document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const headerShell = document.querySelector('[data-header-shell]');
  const menu = document.querySelector('[data-menu-drawer]');
  const search = document.querySelector('[data-search-overlay]');
  const wishlist = document.querySelector('[data-wishlist-drawer]');
  const overlay = document.querySelector('[data-luxe-overlay]');

  const setHeader = () => {
    if (headerShell) headerShell.classList.toggle('is-sticky', window.scrollY > 48);
  };
  setHeader();
  window.addEventListener('scroll', setHeader, { passive: true });

  const closePanels = () => {
    [menu, search, wishlist, overlay].forEach((panel) => {
      if (panel) panel.hidden = true;
    });
    body.classList.remove('luxe-panel-open');
    document.querySelectorAll('[aria-expanded="true"]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
  };

  const openPanel = (panel, trigger, useOverlay = false) => {
    closePanels();
    if (!panel) return;
    panel.hidden = false;
    if (useOverlay && overlay) overlay.hidden = false;
    body.classList.add('luxe-panel-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  };

  const menuOpen = document.querySelector('[data-menu-toggle]');
  const searchOpen = document.querySelector('[data-search-open]');
  const wishlistOpeners = document.querySelectorAll('[data-wishlist-open]');
  menuOpen?.addEventListener('click', () => openPanel(menu, menuOpen, true));
  searchOpen?.addEventListener('click', () => {
    openPanel(search, searchOpen);
    window.setTimeout(() => document.querySelector('#LuxeSearchInput')?.focus(), 80);
  });
  wishlistOpeners.forEach((wishlistOpen) => wishlistOpen.addEventListener('click', () => {
    openPanel(wishlist, wishlistOpen, true);
    renderWishlist();
  }));
  document.querySelectorAll('[data-menu-close],[data-search-close],[data-wishlist-close],[data-luxe-overlay]').forEach((button) => button.addEventListener('click', closePanels));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closePanels();
  });

  const reveals = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach((element) => observer.observe(element));
  } else {
    reveals.forEach((element) => element.classList.add('is-visible'));
  }

  document.querySelectorAll('[data-scroll-rail]').forEach((rail) => {
    const section = rail.closest('section');
    section?.querySelector('[data-scroll-prev]')?.addEventListener('click', () => rail.scrollBy({ left: -rail.clientWidth * 0.72, behavior: 'smooth' }));
    section?.querySelector('[data-scroll-next]')?.addEventListener('click', () => rail.scrollBy({ left: rail.clientWidth * 0.72, behavior: 'smooth' }));
  });

  document.querySelectorAll('[data-hero-slider]').forEach((slider) => {
    const slides = [...slider.querySelectorAll('[data-hero-slide]')];
    const dots = [...slider.querySelectorAll('[data-hero-dot]')];
    if (slides.length < 2) return;
    let active = 0;
    let timer;
    const delay = Number(slider.dataset.autoplay) || 6000;
    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, position) => {
        const selected = position === active;
        slide.classList.toggle('is-active', selected);
        slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
      });
      dots.forEach((dot, position) => {
        const selected = position === active;
        dot.classList.toggle('is-active', selected);
        dot.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
    };
    const start = () => {
      window.clearInterval(timer);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = window.setInterval(() => show(active + 1), delay);
    };
    dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.index)); start(); }));
    slider.addEventListener('mouseenter', () => window.clearInterval(timer));
    slider.addEventListener('mouseleave', start);
    start();
  });

  const wishlistKey = 'eryne-wishlist';
  const getWishlist = () => {
    try { return JSON.parse(localStorage.getItem(wishlistKey) || '[]'); } catch (error) { return []; }
  };
  const setWishlist = (items) => {
    localStorage.setItem(wishlistKey, JSON.stringify(items));
    syncWishlistButtons();
  };
  const syncWishlistButtons = () => {
    const items = getWishlist();
    document.querySelectorAll('[data-wishlist-count]').forEach((count) => { count.textContent = String(items.length); });
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const card = button.closest('[data-product-handle]');
      const handle = card?.dataset.productHandle || button.dataset.productHandle;
      const active = Boolean(handle && items.includes(handle));
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();
    const card = button.closest('[data-product-handle]');
    const handle = card?.dataset.productHandle || button.dataset.productHandle;
    if (!handle) return;
    const items = getWishlist();
    setWishlist(items.includes(handle) ? items.filter((item) => item !== handle) : [...items, handle]);
  });

  const money = (cents) => {
    const currency = window.Shopify?.currency?.active || 'USD';
    return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100);
  };

  async function renderWishlist() {
    const container = document.querySelector('[data-wishlist-items]');
    const empty = document.querySelector('[data-wishlist-empty]');
    if (!container || !empty) return;
    const handles = getWishlist();
    container.innerHTML = '';
    empty.hidden = handles.length > 0;
    const products = await Promise.all(handles.map((handle) => fetch(`/products/${handle}.js`).then((response) => response.ok ? response.json() : null).catch(() => null)));
    products.filter(Boolean).forEach((product) => {
      const card = document.createElement('div');
      card.className = 'luxe-wishlist-card';
      const image = product.featured_image ? `<img src="${product.featured_image}" alt="">` : '';
      card.innerHTML = `<a href="${product.url}">${image}</a><a href="${product.url}"><strong>${product.title}</strong><span>${money(product.price)}</span></a><button type="button" aria-label="Remove" data-wishlist-remove="${product.handle}">×</button>`;
      container.appendChild(card);
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-remove]');
    if (!button) return;
    setWishlist(getWishlist().filter((handle) => handle !== button.dataset.wishlistRemove));
    renderWishlist();
  });
  syncWishlistButtons();

  document.querySelectorAll('a[href]').forEach((link) => {
    const raw = link.getAttribute('href');
    if (!raw || raw.startsWith('#') || raw.startsWith('mailto:') || raw.startsWith('tel:') || link.target === '_blank') return;
    link.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const destination = new URL(link.href, window.location.href);
      if (destination.origin !== window.location.origin) return;
      if (destination.pathname === window.location.pathname && destination.search === window.location.search && destination.hash) return;
      const transition = document.querySelector('.page-transition');
      if (!transition) return;
      event.preventDefault();
      transition.style.transform = 'translateY(0)';
      window.setTimeout(() => { window.location.href = destination.href; }, 480);
    });
  });
});
